import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function WhatIsAgenticWorkflow() {

    return (
        <div>
            <DHeader>What is an Agentic Workflow?</DHeader>

            <DText> 
                An Agentic Workflow is a workflow that contains agents as some of the nodes.
            </DText>
       
          
       
        </div>
    )
}